import Tabs from './Tabs'
import Tab from './Tab'
import TabGroup from './TabGroup'

export { Tab, TabGroup }
export default Tabs
